import { connect } from 'react-redux';
import type { DataById } from 'state/formData/formData.model';
import { getFormEnrichedData } from 'state/formData/formData.selectors';
import { productSummaryClosed } from 'state/productSummaryDescription/productSummaryDescription.action';
import { getFormQuoteId, getStaticFormInfos, isProductSummaryOpened } from 'state/selectors';
import { getQuoteExternalIdByWorkspaceTab } from 'state/selectors/common/temp';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import type { BatchWorkspaceVersion, QuoteWorkspaceVersion } from 'state/userPreferences/userPreferences.model';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

import type { ProductSummaryMetadata } from './builder/model';

interface OwnProps {
  tabId: string;
  quoteWorkspaceVersion: QuoteWorkspaceVersion;
  batchWorkspaceVersion: BatchWorkspaceVersion;
  mustForceAdvancedMode: boolean;

  workspaceType: QuoteWorkspaceType;
}
interface StateProps {
  externalQuoteId?: string;
  quoteId?: string;
  formEnrichedData?: DataById;
  isOpened: boolean;
  summaryMetaData?: ProductSummaryMetadata;
}

interface DispatchProps {
  onCloseSummary(): void;
}

export type SummaryProps = OwnProps & StateProps & DispatchProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const externalQuoteId = getQuoteExternalIdByWorkspaceTab(state, 'static', tabId);
  const quoteId = getFormQuoteId(state, 'static', tabId);
  const formInfos = getStaticFormInfos(state, tabId)!;

  return {
    externalQuoteId,
    quoteId,
    formEnrichedData: getFormEnrichedData(state, tabId),
    isOpened: isProductSummaryOpened(state, tabId),
    summaryMetaData: formInfos?.summary?.payload,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps): DispatchProps => ({
  onCloseSummary() {
    dispatch(productSummaryClosed(tabId));
  },
});

export const connectSummary = connect(mapStateToProps, mapDispatchToProps);
